import { render, staticRenderFns } from "@/modules/Policy/templates/policy-detail.html?vue&type=template&id=74566a05&scoped=true&"
import script from "@/modules/Policy/scripts/policy-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Policy/scripts/policy-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Policy/styles/policy-detail.scss?vue&type=style&index=0&id=74566a05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74566a05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VImg,VTooltip})
